import { TFunction } from 'i18next'
import { object, SchemaOf, string } from 'yup'

import { getPasswordValidationSchema } from '../../../../../utils/getPasswordValidationSchema'

export interface PasswordForm {
  oldPassword: string
  newPassword: string
}

export type PasswordFormSchema = SchemaOf<PasswordForm>

export const getValidationSchema = (t: TFunction): PasswordFormSchema =>
  object({
    oldPassword: string().required(t('settings.user.profile.password')),
    newPassword: getPasswordValidationSchema(t).required(t('settings.user.profile.password')),
  })

export const getDefaultValues = (): PasswordForm => ({
  oldPassword: '',
  newPassword: '',
})
